import { ws } from "../../../utils/common";

export const getAssociationWS = async ({ id_association }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/info/" + id_association,
    { dashboard: false },
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const getAllTopicWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "topic/",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const updateAssociationWS = async ({ id_association, formData }) => {
  console.log("POOST::: ");
  for (const [key, value] of formData.entries()) {
    console.log(`${key}: ${value}`);
  }
  const res = await ws(
    "PUT",
    process.env.REACT_APP_ENDPOINT + "association/" + id_association,
    null,
    formData,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
